// removed by extract-text-webpack-plugin
module.exports = {"container":"ZhttVgU4twSFgS3gHc2o5","suggestionsContainer":"_2Fh3SioJlyyRn-qGALPIaF","suggestionsContainerOpen":"_WD-oeZyqeOgD1QsOnWE6","suggestionsList":"_3hK2tEM6FvJhGigMAASS42","suggestion":"_3ATSAvwwDXRrLz1GVhlAex","suggestionHighlighted":"_1GP7dCoeI34senwIvBLoDr","sectionContainer":"_31dBsCZi0-kcS7R8dFlrUB","sectionContainerFirst":"GmOPBK3YrSBAcTFTSPet_","sectionTitle":"_3ohlST-fB81joyq04OwBT-"};


//////////////////
// WEBPACK FOOTER
// ./src/forms/components/schoolSearch/schoolSearchComponent.scss
// module id = 689
// module chunks = 22